module.exports = __webpack_public_path__ + "media/images/reviews/yelp-dce7d3f4ced4e0c9651d7f063afb43c1.svg";